import AxiosInstance from 'utils/AxiosInstance'
import {
  SET_CONVERSATIONS,
  SET_NAVBAR_CONVERSATIONS,
  SET_CONVERSATIONS_DETAILS,
  SET_MESSAGES,
  SET_LOAD_MESSAGES,
  SET_LOAD_FAIL,
  RESET_SELECTED_ITEMS,
  SET_ASSIGN_SEARCH_VALUE,
  TOGGLE_MODAL,
  SET_CURRENT_TAB,
  SET_CURRENT_SELECTED_ITEMS,
  SET_CURRENT_ITEMS,
  SET_CURRENT_TOGGLE_ITEM_FUNCTION,
  SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION,
  SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION,
  SET_CURRENT_SHOW_SELECTED_ITEMS,
  SET_SHOW_SELECTED_STORES,
  SET_SELECTED_ORG_GROUPS,
  SET_SELECTED_USERS,
  SET_SELECTED_LOCATION_GROUPS,
  SET_SELECTED_LOCATIONS,
  SET_SELECTED_STORES,
  SET_SELECTED_ROLES_FILTER,
  SET_SELECTED_ROLES,
  SET_SHOW_SELECTED_ORG_GROUPS,
  SET_SHOW_SELECTED_USERS,
  SET_SHOW_SELECTED_USERS_ITEMS,
  SET_SHOW_SELECTED_LOCATIONS,
  SET_SHOW_SELECTED_LOCATION_GROUPS,
  SET_SHOW_SELECTED_ROLES,
  INCREASE_LIMIT,
  RESET_CHAT,
  SET_TOTAL_MESSAGES,
  SET_ALL_USERS,
  SET_CREATING_CONVERSATION_LOADING,
  SET_LOADING_MORE,
  SET_ARCHIVING_MESSAGES,
  SET_EDITED_MESSAGES,
  SET_GROUP_MEMBERS,
  SET_LOADING_CONVERSATIONS,
  SET_LOADING_MESSAGES,
} from './constants'

export const setLoadMoreMessages = (value) => ({
  type: SET_LOADING_MORE,
  payload: value,
})

export const setNavbarConversations = () => {
  return (dispatch, getState) => {
    AxiosInstance.get('/conversations?home=true').then((data) => {
      dispatch({ type: SET_NAVBAR_CONVERSATIONS, payload: data })
    })
  }
}

export const setConversations = () => {
  return async (dispatch, getState) => {
    dispatch({ type: SET_LOADING_CONVERSATIONS, loading: true })

    AxiosInstance.get('/conversations').then((data) => {
      dispatch({ type: SET_CONVERSATIONS, payload: data })
      dispatch({ type: SET_LOADING_CONVERSATIONS, loading: false })
    })
  }
}

export const updateConversationReadStatus = (conversationId) => {
  return (dispatch, getState) => {
    AxiosInstance.put(`/conversations/${conversationId}`).then(() => {
      dispatch(setNavbarConversations())
    })
  }
}

export const updateGroupConversationReadStatus = (id) => {
  return (dispatch, getState) => {
    AxiosInstance.put(`/conversations/group/${id}/read`).then(() => {
      dispatch(setNavbarConversations())
    })
  }
}

export const fetchConversationDetails = (conversationId) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/conversations/${conversationId}`).then((data) => {
      dispatch({ type: SET_CONVERSATIONS_DETAILS, payload: data })
    })
  }
}

export const createMessage = (conversationId, message) => {
  return (dispatch, getState) => {
    AxiosInstance.post(`/messages/${conversationId}`, { message }).then(() => {
      console.log('patrik41')
    })
  }
}

export const unsendMessage = (messageId) => {
  return (dispatch, getState) => {
    const { activeConversation } = getState().chat

    AxiosInstance.delete(`/messages/${messageId}`).then(() => {
      dispatch(fetchMessages(activeConversation.id))
    })
  }
}

export const updateMessage = (messageId, newMessage) => {
  return (dispatch, getState) => {
    const { activeConversation } = getState().chat

    AxiosInstance.put(`/messages/${messageId}`, { message: newMessage }).then(
      () => {
        dispatch(fetchMessages(activeConversation.id))
      }
    )
  }
}

export const fetchMessages = (conversationId) => {
  return (dispatch, getState) => {

    dispatch({ type: SET_LOADING_MESSAGES, loading: true })

    const { limit } = getState().chat

    AxiosInstance.get(`/messages/${conversationId}?limit=${limit}`).then(
      (data) => {
        dispatch({ type: SET_MESSAGES, payload: data })
        dispatch({ type: SET_LOADING_MESSAGES, loading: false })
      }
    )
  }
}

export const fetchAllUsers = () => {
  return (dispatch, getState) => {
    AxiosInstance.get('/users/all-users?messages=true').then((data) => {
      dispatch({ type: SET_ALL_USERS, payload: data })
    })
  }
}

export const archiveConversations = () => {
  return (dispatch, getState) => {
    dispatch({ type: SET_ARCHIVING_MESSAGES, payload: true })

    AxiosInstance.delete('/conversations/archive').then(() => {
      dispatch({ type: SET_ARCHIVING_MESSAGES, payload: false })
    })
  }
}

export const createNewConversation = (message) => {
  return (dispatch, getState) => {
    dispatch({ type: SET_CREATING_CONVERSATION_LOADING, payload: true })

    const {
      selectedOrgGroups,
      selectedLocationGroups,
      selectedLocations,
      selectedRoles,
      selectedUsers,
      selectedStores,
    } = getState().chat

    if (
      !selectedOrgGroups.length &&
      !selectedLocationGroups.length &&
      !selectedRoles.length &&
      !selectedUsers.length &&
      !selectedStores.length
    ) {
      alert('Please choose a recipent!')
      dispatch({ type: SET_CREATING_CONVERSATION_LOADING, payload: false })
      return
    }

    const data = {
      groups: [...selectedOrgGroups, ...selectedLocationGroups],
      users: selectedUsers,
      stores: selectedStores,
      roles: selectedRoles,
      message,
    }

    return AxiosInstance.post('/conversations', data).then(() => {
      dispatch({ type: SET_CREATING_CONVERSATION_LOADING, payload: false })
    })
  }
}

export const createNewGroup = (name, image) => {
  return (dispatch, getState) => {
    const { selectedUsers } = getState().chat

    const formData = new FormData()
    formData.append('users', selectedUsers)
    formData.append('name', name)
    formData.append('image', image)

    AxiosInstance.post('/conversations/group', formData).then(() => {})
  }
}

export const updateGroup = (id, name = '', image = null) => {
  return (dispatch, getState) => {
    const formData = new FormData()
    if (name) {
      formData.append('name', name)
    }
    if (image) {
      formData.append('image', image)
    }

    AxiosInstance.put(`/conversations/group/${id}`, formData).then(() =>
      dispatch(fetchConversationDetails(id))
    )
  }
}

export const increaseLimit = () => ({ type: INCREASE_LIMIT })
export const resetChat = () => ({ type: RESET_CHAT })
export const setTotalMessages = (conversationId) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/messages/${conversationId}/total`).then((data) => {
      dispatch({ type: SET_TOTAL_MESSAGES, payload: data?.total_messages })
      dispatch({ type: SET_EDITED_MESSAGES, payload: data?.edited_messages })
    })
  }
}

export const resetSelectedItems = () => ({ type: RESET_SELECTED_ITEMS })
export const setAssignSearchValue = (assignSearchValue) => ({
  type: SET_ASSIGN_SEARCH_VALUE,
  assignSearchValue,
})
export const handleToggleModal = (modal) => {
  return (dispatch) => {
    if (modal === false) {
      dispatch(resetSelectedItems())
      dispatch(
        setCurrentTab(
          null,
          'category',
          'selectedOrgGroups',
          'groupOrgs',
          'toggleOrgGroups',
          'showSelectedOrgGroups',
          'setShowSelectedOrgGroups',
          'setHideSelectedOrgGroups'
        )
      )
      dispatch(setAssignSearchValue(''))
    }
    dispatch({
      type: TOGGLE_MODAL,
      payload: modal,
    })
  }
}
export const setCurrentTab = (
  event,
  currentTab,
  currentSelectedItems,
  currentItems,
  currentToggleFunction,
  currentShowSelectedItems,
  currentShowSelectedItemsFunction,
  currentHideSelectedItemsFunction
) => {
  return (dispatch) => {
    if (event !== null) {
      event.preventDefault()
    }
    dispatch({ type: SET_CURRENT_TAB, currentTab })
    dispatch({ type: SET_CURRENT_SELECTED_ITEMS, currentSelectedItems })
    dispatch({ type: SET_CURRENT_ITEMS, currentItems })
    dispatch({
      type: SET_CURRENT_TOGGLE_ITEM_FUNCTION,
      currentToggleFunction,
    })
    dispatch({
      type: SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION,
      currentHideSelectedItemsFunction,
    })
    dispatch({
      type: SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION,
      currentShowSelectedItemsFunction,
    })
    dispatch({
      type: SET_CURRENT_SHOW_SELECTED_ITEMS,
      currentShowSelectedItems,
    })
  }
}
export const toggleOrgGroups = (id) => {
  return (dispatch, getState) => {
    const { selectedOrgGroups } = getState().chat

    const index = selectedOrgGroups.indexOf(id)

    let orgGroups = []

    if (index !== -1) {
      orgGroups = [
        ...selectedOrgGroups.slice(0, index),
        ...selectedOrgGroups.slice(index + 1),
      ]
    } else {
      orgGroups = [...selectedOrgGroups, id]
    }

    dispatch({ type: SET_SELECTED_ORG_GROUPS, orgGroups })
  }
}
export const toggleUsers = (id) => {
  return (dispatch, getState) => {
    const { selectedUsers } = getState().chat

    const index = selectedUsers.indexOf(id)

    let users = []

    if (index !== -1) {
      users = [
        ...selectedUsers.slice(0, index),
        ...selectedUsers.slice(index + 1),
      ]
    } else {
      users = [...selectedUsers, id]
    }

    dispatch({ type: SET_SELECTED_USERS, users })
  }
}
export const toggleLocationGroups = (id) => {
  return (dispatch, getState) => {
    const { selectedLocationGroups } = getState().chat

    const index = selectedLocationGroups.indexOf(id)

    let locationGroups = []

    if (index !== -1) {
      locationGroups = [
        ...selectedLocationGroups.slice(0, index),
        ...selectedLocationGroups.slice(index + 1),
      ]
    } else {
      locationGroups = [...selectedLocationGroups, id]
    }

    dispatch({ type: SET_SELECTED_LOCATION_GROUPS, locationGroups })
  }
}
export const toggleLocations = (id) => {
  return (dispatch, getState) => {
    const { selectedLocations } = getState().chat

    const index = selectedLocations.indexOf(id)

    let locations = []

    if (index !== -1) {
      locations = [
        ...selectedLocations.slice(0, index),
        ...selectedLocations.slice(index + 1),
      ]
    } else {
      locations = [...selectedLocations, id]
    }

    dispatch({ type: SET_SELECTED_LOCATIONS, locations })
  }
}
export const toggleStores = (id) => {
  return (dispatch, getState) => {
    const { selectedStores } = getState().chat

    const index = selectedStores.indexOf(id)

    let stores = []

    if (index !== -1) {
      stores = [
        ...selectedStores.slice(0, index),
        ...selectedStores.slice(index + 1),
      ]
    } else {
      stores = [...selectedStores, id]
    }

    dispatch({ type: SET_SELECTED_STORES, stores })
  }
}
export const setRolesFilter = (value) => ({
  type: SET_SELECTED_ROLES_FILTER,
  value,
})
export const toggleRoles = (id) => {
  return (dispatch, getState) => {
    const { selectedRoles } = getState().chat

    const index = selectedRoles.indexOf(id)

    let roles = []

    if (index !== -1) {
      roles = [
        ...selectedRoles.slice(0, index),
        ...selectedRoles.slice(index + 1),
      ]
    } else {
      roles = [...selectedRoles, id]
    }

    dispatch({ type: SET_SELECTED_ROLES, roles })
  }
}
export const setShowSelectedOrgGroups = () => ({
  type: SET_SHOW_SELECTED_ORG_GROUPS,
  showSelectedOrgGroups: true,
})
export const setShowSelectedUsers = () => ({
  type: SET_SHOW_SELECTED_USERS,
  showSelectedUsers: true,
})
export const setHideSelectedUsers = () => ({
  type: SET_SHOW_SELECTED_USERS,
  showSelectedUsers: false,
})
export const setShowSelectedUsersItems = () => ({
  type: SET_SHOW_SELECTED_USERS_ITEMS,
  showSelectedUsersItems: true,
})
export const setHideSelectedUsersItems = () => ({
  type: SET_SHOW_SELECTED_USERS_ITEMS,
  showSelectedUsersItems: false,
})
export const setShowSelectedLocations = () => ({
  type: SET_SHOW_SELECTED_LOCATIONS,
  showSelectedLocations: true,
})
export const setHideSelectedLocations = () => ({
  type: SET_SHOW_SELECTED_LOCATIONS,
  showSelectedLocations: false,
})
export const setShowSelectedLocationGroups = () => ({
  type: SET_SHOW_SELECTED_LOCATION_GROUPS,
  showSelectedLocationGroups: true,
})
export const setHideSelectedLocationGroups = () => ({
  type: SET_SHOW_SELECTED_LOCATION_GROUPS,
  showSelectedLocationGroups: false,
})
export const setShowSelectedRoles = () => ({
  type: SET_SHOW_SELECTED_ROLES,
  showSelectedRoles: true,
})
export const setHideSelectedRoles = () => ({
  type: SET_SHOW_SELECTED_ROLES,
  showSelectedRoles: false,
})
export const setHideSelectedOrgGroups = () => ({
  type: SET_SHOW_SELECTED_ORG_GROUPS,
  showSelectedOrgGroups: false,
})
export const setShowSelectedStores = () => ({
  type: SET_SHOW_SELECTED_STORES,
  showSelectedStores: true,
})
export const setHideSelectedStores = () => ({
  type: SET_SHOW_SELECTED_STORES,
  showSelectedStores: false,
})

export const setGroupMembers = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/conversations/group/${id}/members`).then((data) =>
      dispatch({ type: SET_GROUP_MEMBERS, payload: data })
    )
  }
}

export const removeGroupMember = (id, memberId) => {
  return (dispatch) => {
    AxiosInstance.delete(`/conversations/group/${id}/member/${memberId}`).then(
      () => dispatch(setGroupMembers(id))
    )
  }
}

export const addMembers = (id) => {
  return (dispatch, getState) => {
    const { selectedUsers } = getState().chat
    AxiosInstance.post(`/conversations/group/${id}/members`, {
      userIds: selectedUsers,
    }).then(() => dispatch(setGroupMembers(id)))
  }
}
